
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-gpk/pejabat-penilai-kinerja/periodik",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-gpk/pejabat-penilai-kinerja/periodik/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-gpk/pejabat-penilai-kinerja/periodik"])
      });
    }
  